import { useEffect, useState } from 'react'
import { useSearchParams } from 'next/navigation'
import { type NextRouter } from 'next/router'

interface UseRedirectToParams {
  router: NextRouter
  onReady?: (redirectTo: string) => void
}

export const useRedirectTo = ({ router, onReady }: UseRedirectToParams) => {
  const [redirectTo, setRedirectTo] = useState<string>('')
  const searchParams = useSearchParams()
  const routerIsReady = router.isReady

  useEffect(() => {
    if (routerIsReady) {
      const redirectToParm = searchParams.get('redirect_to') || ''
      setRedirectTo(redirectToParm)

      if (onReady) {
        onReady(redirectToParm)
      }
    }
  }, [routerIsReady])

  return { redirectTo }
}
